export const getPosRegisterStorageKey = (branchId) => `pos_cash_register_${branchId}`;
export const getPosSessionStorageKey = (branchId) => `pos_cash_session_${branchId}`;

export const resolveCurrentPosScope = ({
  registers = [],
  userId,
  storedRegisterId,
  storedSessionId,
}) => {
  const list = Array.isArray(registers) ? registers : [];
  const canUseSession = (session) =>
    session && String(session.openedBy) === String(userId);

  let selectedRegister = list.find(
    (register) => String(register.id) === String(storedRegisterId)
  );
  let session = selectedRegister?.activeSession || null;

  if (session && storedSessionId && String(session.id) !== String(storedSessionId)) {
    session = null;
  }
  if (session && !canUseSession(session)) {
    session = null;
  }

  if (!session) {
    const fallback = list.find((register) => canUseSession(register.activeSession));
    if (fallback) {
      selectedRegister = fallback;
      session = fallback.activeSession;
    }
  }

  if (!selectedRegister && session?.cashRegisterId != null) {
    selectedRegister = list.find(
      (register) => String(register.id) === String(session.cashRegisterId)
    );
  }

  return { selectedRegister: selectedRegister || null, session: session || null };
};
